import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation resources
const resources = {
  de: {
    translation: {
      home: "Startseite",
      services: "Dienstleistungen",
      projects: "Projekte",
      about: "Über uns",
      contact: "Kontakt",
      welcome: "Willkommen auf unserer Website",
      emibau: "EMIBAU",
      hero_description:
        "Emibau bietet zuverlässige Trockenbau-Dienstleistungen, basierend auf Erfahrung, Präzision und Qualität.",
      home_get_a_quote: "Angebot anfordern",

      home_drywall_installation_title: "Trockenbau Installation",
      home_drywall_installation_desc:
        "Professioneller Trockenbau für Wohn- und Gewerberäume. Wir liefern saubere Oberflächen, präzise Ausrichtung und langlebige Ergebnisse.",

      interior_partition_title: "Innenraum-Trennwände",
      interior_partition_desc:
        "Individuelle Wandtrennwände, die Ihren Raum optimal gestalten. Perfekt für Büros, Wohnungen und Renovierungen.",

      excavator_rentals_title: "Baggervermietung",
      excavator_rentals_desc:
        "Zuverlässige Baggervermietung für Bau-, Landschafts- und Erdarbeiten, sicher und effizient betrieben.",

      specialized_for: "SPEZIALISIERT FÜR",
      specialized_desc:
        "Wir sind spezialisiert auf professionellen Trockenbau und liefern präzise und langlebige Ergebnisse. Unser erfahrenes Team kombiniert Fertigkeit, Detailgenauigkeit und moderne Techniken für perfekte Ergebnisse.",

      what_we_offer: "WAS WIR BIETEN",
      offer_quality: "Qualität & Präzision",
      offer_quality_desc:
        "Präzise Handwerkskunst trifft auf höchste Qualität bei jeder Installation.",
      offer_equipment: "Moderne Ausrüstung",
      offer_equipment_desc:
        "Unsere modernen Bagger garantieren maximale Effizienz und Sicherheit.",
      offer_team: "Erfahrenes Team",
      offer_team_desc:
        "Unser Team bringt Erfahrung, Hingabe und Präzision in jedes Projekt.",

      discover_our_work: "ENTDECKEN SIE UNSERE ARBEIT",
      discover_our_work_desc:
        "Entdecken Sie unsere Projekte und sehen Sie die Qualität und Präzision, die wir liefern.",
      our_projects: "Unsere Projekte",
      services_hero_title: "Unsere Dienstleistungen",
      services_hero_desc:
        "Emibau bietet professionelle Bau- und Gerätevermietungen und garantiert Qualität, Sicherheit und Effizienz bei jedem Projekt.",
      general_construction: "Allgemeine Bauleistungen",
      general_construction_desc:
        "Komplette Bau-Lösungen für Wohn- und Gewerbeprojekte, präzise ausgeführt mit hochwertigen Materialien.",
      drywall_installation: "Trockenbau Installation",
      services_drywall_installation_desc:
        "Professionelle Trockenbauinstallation und -fertigstellung für glatte, langlebige und moderne Innenräume.",
      renovation_remodeling: "Renovierung & Umbau",
      renovation_remodeling_desc:
        "Verbessern und transformieren Sie bestehende Räume mit professionellen Renovierungs- und Umbaulösungen.",
      excavator_rental: "Baggervermietung",
      excavator_rental_desc:
        "Zuverlässige Baggervermietung für Erdarbeiten und Bauprojekte jeder Größe.",
      site_preparation: "Bauplatzvorbereitung",
      site_preparation_desc:
        "Bodenvorbereitung, Erdarbeiten und Flächenräumung für eine sichere und stabile Grundlage.",
      equipment_rental: "Gerätevermietung",
      equipment_rental_desc:
        "Baumaschinen und Geräte für flexible Kurz- oder Langzeitmiete verfügbar.",
      request_quote: "Kostenloses Angebot anfordern",
      request_quote_desc:
        "Haben Sie ein Projekt im Sinn? Kontaktieren Sie Emibau und erhalten Sie ein individuelles Angebot.",
      services_get_a_quote: "Angebot anfordern",
      projects_title: "Unsere Projekte",
      projects_desc:
        "Eine Auswahl unserer Bau-, Renovierungs- und Designarbeiten. Präzise, qualitativ und vertrauenswürdig umgesetzt.",
      projects_get_a_quote: "Angebot anfordern",
      see_more: "Mehr Anzeigen",
      see_less: "Weniger Anzeigen",
      project_residential_build: "Wohnbau",
      project_commercial: "Gewerbeprojekt",
      project_renovation: "Renovierung",
      project_interior: "Innenausbau",
      project_exterior: "Außendesign",
      project_office: "Bürobau",
      project_custom: "Individuelles Projekt",
      project_modern_house: "Modernes Haus",
      project_drywall: "Trockenbau",
      project_wall_mounting: "Wandmontage",
      project_construction_house: "Bau eines Hauses",
      project_renovation_home: "Hausrenovierung",
      about_title: "Über Emibau",
      about_description:
        "Emibau ist ein vertrauenswürdiges Bauunternehmen, das sich auf hochwertige Trockenbau-Lösungen und professionelle Baggervermietungen spezialisiert. Wir kombinieren Präzision, Erfahrung und moderne Ausrüstung, um zuverlässige Ergebnisse für Wohn- und Gewerbeprojekte zu liefern.",
      about_projects: "Unsere Projekte",
      about_contact: "Kontaktieren Sie uns",

      drywall_img_alt: "Trockenbau",
      drywall_title: "Trockenbau",
      drywall_desc:
        "Von Trennwänden bis zu Decken – unsere Trockenbau-Dienstleistungen garantieren saubere Oberflächen, Langlebigkeit und schnelle Installation, individuell auf Ihren Raum zugeschnitten.",

      excavator_img_alt: "Baggervermietung",
      excavator_title: "Baggervermietung",
      excavator_desc:
        "Wir bieten zuverlässige Baggervermietungen mit moderner Ausrüstung, ideal für Bau-, Erd- und Landschaftsprojekte.",

      why_us_title: "Warum Emibau wählen",
      why_us_subtitle:
        "Wir liefern qualitativ hochwertige Arbeit, zuverlässige Geräte und professionellen Service bei jedem Projekt, groß oder klein.",
      why_team_title: "Erfahrenes Team",
      why_team_desc:
        "Unsere Fachleute bringen jahrelange Erfahrung im Trockenbau und in der Bedienung von Baumaschinen mit.",
      why_equipment_title: "Moderne Ausrüstung",
      why_equipment_desc:
        "Wir verwenden gut gewartete, moderne Bagger für Effizienz, Sicherheit und Zuverlässigkeit vor Ort.",
      why_quality_title: "Qualität & Präzision",
      why_quality_desc:
        "Jedes Detail zählt. Wir legen Wert auf Präzision, Langlebigkeit und saubere Oberflächen, die Bestand haben.",
      why_delivery_title: "Termingerechte Lieferung",
      why_delivery_desc:
        "Wir halten Termine ein und liefern Projekte pünktlich, ohne die Qualität zu beeinträchtigen.",
      contact_title: "Kontaktieren Sie Emibau",
      contact_description:
        "Haben Sie ein Projekt im Sinn oder benötigen zuverlässige Trockenbauleistungen oder Baggervermietungen? Kontaktieren Sie uns noch heute, wir helfen gerne.",
      contact_get_in_touch: "Kontakt aufnehmen",
      contact_address: "Bamberg, Deutschland",
      contact_phone: "+49 1522 1322803",
      contact_email: "emi.qazimi90@gmail.com",
      contact_info_description:
        "Wir antworten schnell auf alle Anfragen und besprechen gerne Ihre Projektanforderungen, Zeitpläne und Preise.",
      contact_form_title: "Senden Sie uns eine Nachricht",
      contact_placeholder_name: "Vollständiger Name",
      contact_placeholder_email: "E-Mail-Adresse",
      contact_placeholder_phone: "Telefonnummer",
      contact_placeholder_message: "Ihre Nachricht",
      contact_send_button: "Nachricht senden",
      footer_about_text:
        "Emibau ist ein vertrauenswürdiges Bauunternehmen, das hochwertige Wohn- und Gewerbeprojekte präzise, zuverlässig und exzellent umsetzt.",
      footer_quick_links: "Schnellzugriffe",
      footer_contact: "Kontakt",
      footer_rights: "Alle Rechte vorbehalten.",
      nav_home: "Startseite",
      nav_services: "Dienstleistungen",
      nav_projects: "Projekte",
      nav_about: "Über uns",
      nav_contact: "Kontakt",
      contact_sending: "Wird gesendet…",
      contact_success: "Ihre Nachricht wurde erfolgreich gesendet!",
      contact_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      contact_error_name: "Bitte geben Sie Ihren Namen ein",
      contact_error_email_required: "E-Mail-Adresse ist erforderlich",
      contact_error_email_invalid:
        "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      contact_error_message: "Bitte geben Sie eine Nachricht ein",
    },
  },

  en: {
    translation: {
      home: "Home",
      services: "Services",
      projects: "Projects",
      about: "About Us",
      contact: "Contact",
      welcome: "Welcome to our website",
      emibau: "EMIBAU",
      hero_description:
        "Emibau provides reliable drywall construction services, built on experience, precision, and a commitment to quality.",
      home_get_a_quote: "Get a Quote",

      home_drywall_installation_title: "Drywall Installation",
      home_drywall_installation_desc:
        "Professional drywall construction for residential and commercial spaces. We deliver clean finishes, precise alignment, and long-lasting results.",

      interior_partition_title: "Interior Partitioning",
      interior_partition_desc:
        "Custom wall partitions designed to optimize your space based on your preferences and style. Perfect for offices, homes, and renovations.",

      excavator_rentals_title: "Excavator Rentals",
      excavator_rentals_desc:
        "Reliable excavator rental services for construction, landscaping, and groundwork projects, operated safely and efficiently.",

      specialized_for: "SPECIALIZED FOR",
      specialized_desc:
        "We specialize in professional drywall construction, delivering precise and durable installations. Our experienced team combines skill, attention to detail, and modern techniques for flawless finishes.",

      what_we_offer: "WHAT WE OFFER",
      offer_quality: "Quality & Precision",
      offer_quality_desc:
        "Precision craftsmanship meets premium quality in every drywall installation.",
      offer_equipment: "Modern Equipment",
      offer_equipment_desc:
        "Our fleet of modern excavators guarantees high performance and efficiency.",
      offer_team: "Experienced Team",
      offer_team_desc:
        "Our experienced team brings skill, dedication, and attention to detail to every project.",

      discover_our_work: "DISCOVER OUR WORK",
      discover_our_work_desc:
        "Discover our work and see the quality and precision we bring to every project.",
      our_projects: "Our Projects",
      services_hero_title: "Our Services",
      services_hero_desc:
        "Emibau offers professional construction and equipment rental services, delivering quality, safety, and efficiency on every project.",
      general_construction: "General Construction",
      general_construction_desc:
        "Complete construction solutions for residential and commercial projects, built with precision and high-quality materials.",
      drywall_installation: "Drywall Installation",
      services_drywall_installation_desc:
        "Professional drywall installation and finishing for smooth, durable, and modern interior spaces.",
      renovation_remodeling: "Renovation & Remodeling",
      renovation_remodeling_desc:
        "Upgrade and transform existing spaces with expert renovation and remodeling solutions.",
      excavator_rental: "Excavator Rental",
      excavator_rental_desc:
        "Reliable excavator rental services for excavation, groundwork, and construction projects of any size.",
      site_preparation: "Site Preparation",
      site_preparation_desc:
        "Land clearing, excavation, and site preparation to ensure a safe and solid foundation for your project.",
      equipment_rental: "Equipment Rental",
      equipment_rental_desc:
        "Construction machinery and equipment available for flexible short- or long-term rental.",
      request_quote: "Request a Free Quote",
      request_quote_desc:
        "Have a project in mind? Contact Emibau today and get a customized quote tailored to your construction needs.",
      services_get_a_quote: "Get a Quote",
      projects_title: "Our Projects",
      projects_desc:
        "A selection of our construction, renovation, and design works. Built with precision, quality, and trust.",
      projects_get_a_quote: "Get a Quote",
      see_more: "See More",
      see_less: "See Less",
      project_residential_build: "Residential Build",
      project_commercial: "Commercial Project",
      project_renovation: "Renovation",
      project_interior: "Interior Work",
      project_exterior: "Exterior Design",
      project_office: "Office Construction",
      project_custom: "Custom Build",
      project_modern_house: "Modern House",
      project_drywall: "Drywall",
      project_wall_mounting: "Wall Mounting",
      project_construction_house: "Construction House",
      project_renovation_home: "Renovation Home",
      about_title: "About Emibau",
      about_description:
        "Emibau is a trusted construction company specializing in high-quality drywall solutions and professional excavator rentals. We combine precision, experience, and modern equipment to deliver reliable results for residential and commercial projects.",
      about_projects: "Our Projects",
      about_contact: "Contact Us",

      drywall_img_alt: "Drywall construction",
      drywall_title: "Drywall Construction",
      drywall_desc:
        "From partitions to ceilings, our drywall services ensure clean finishes, durability, and fast installation tailored to your space.",

      excavator_img_alt: "Excavator rental",
      excavator_title: "Excavator Rentals",
      excavator_desc:
        "We provide reliable excavator rentals with modern machinery, ideal for construction, excavation, and landscaping projects.",

      why_us_title: "Why Choose Emibau",
      why_us_subtitle:
        "We deliver quality workmanship, reliable equipment, and professional service on every project, big or small.",
      why_team_title: "Experienced Team",
      why_team_desc:
        "Our skilled professionals bring years of experience in drywall construction and heavy equipment operations.",
      why_equipment_title: "Modern Equipment",
      why_equipment_desc:
        "We use well-maintained, modern excavators to ensure efficiency, safety, and reliability on-site.",
      why_quality_title: "Quality & Precision",
      why_quality_desc:
        "Every detail matters. We focus on precision, durability, and clean finishes that last.",
      why_delivery_title: "On-Time Delivery",
      why_delivery_desc:
        "We respect deadlines and deliver projects on time without compromising quality.",
      contact_title: "Contact Emibau",
      contact_description:
        "Have a project in mind or need reliable drywall services or excavator rentals? Get in touch with us today, we’re ready to help.",
      contact_get_in_touch: "Get in Touch",
      contact_address: "Bamberg, Germany",
      contact_phone: "+49 1522 1322803",
      contact_email: "emi.qazimi90@gmail.com",
      contact_info_description:
        "We respond quickly to all inquiries and are happy to discuss your project requirements, timelines, and pricing.",
      contact_form_title: "Send Us a Message",
      contact_placeholder_name: "Full Name",
      contact_placeholder_email: "Email Address",
      contact_placeholder_phone: "Phone Number",
      contact_placeholder_message: "Your Message",
      contact_send_button: "Send Message",
      footer_about_text:
        "Emibau is a trusted construction company delivering high-quality residential and commercial projects with precision, reliability, and excellence.",
      footer_quick_links: "Quick Links",
      footer_contact: "Contact",
      footer_rights: "All rights reserved.",
      nav_home: "Home",
      nav_services: "Services",
      nav_projects: "Projects",
      nav_about: "About",
      nav_contact: "Contact Us",
      contact_sending: "Sending...",
      contact_success: "Your message has been sent successfully!",
      contact_error: "Something went wrong. Please try again.",
      contact_error_name: "Please enter your name",
      contact_error_email_required: "Email is required",
      contact_error_email_invalid: "Please enter a valid email address",
      contact_error_message: "Please enter a message",
    },
  },
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "de", 
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
